<!--  -->
<template>
    <div class="wrapper">
        <div class="explor">
            <div class="search-div">
                <el-input placeholder="Type here to search" v-model.trim="indexkeyword" @keyup.enter.native="getGlossList">
                    <el-button slot="append" icon="el-icon-search" type="primary" @click="getGlossList">Search</el-button>
                </el-input>
            </div>
            <div class="word-list">
                <ul class="word-list-ul">
                    <li v-for="word in wordList" :key="word" class="word-item" :class="{ 'active': indexkey == word }">
                        <el-button @click="getResult(word)">{{ word }}</el-button>
                    </li>
                </ul>
            </div>
            <div class="gloss-list" ref="gloss-list">
                <waterfall :col='col' :data="glossList" @loadmore="loadmore" :loadDistance="30">
                    <template>
                        <div v-for="(item, index) in glossList" class="waterfall-item" :key="index"
                            @click="toGloss(item.glossary_id)">
                            <h3 class="title" v-html="item.g_title"></h3>
                            <div class="gloss-item-content" v-html="item.g_con">
                            </div>
                        </div>
                    </template>
                </waterfall>
                <loading :show="loading" />
            </div>
            <div class="no-more" v-show="page >= glossTotalPage">没有更多了</div>
        </div>
    </div>
</template>

<script>
import { getGlossary, utlogMap } from "@/api/index";
import { functionId } from '@/utils/browser.js';
import loading from "@/components/loading/loading.vue";
export default {
    name: "explor",
    components: {
        loading,
    },
    computed: {
        gutterWidth() {
            return 20;
        },
    },
    data() {
        return {
            glossTotalPage: 0,
            indexkey: "",
            indexkeyword: "",
            loading: false,
            col: 3,
            wordList: [
                "a",
                "b",
                "c",
                "d",
                "e",
                "f",
                "g",
                "h",
                "i",
                "j",
                "l",
                "m",
                "n",
                "o",
                "p",
                "r",
                "s",
                "t",
                "v",
                "z",
            ],
            glossList: [],
            busy: false,
            page: 1,
            per_page: 20,
        };
    },
    //生命周期 - 创建完成（访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        this.getGlossary();
    },
    methods: {
        getGlossary() {
            getGlossary(
                this.indexkeyword,
                this.indexkey,
                this.per_page,
                this.page
            ).then((res) => {
                let data = res.data?.data || [];
                let meta = res.data?.meta || {};
                let { totalCount = 0, totalPage = 0 } = meta;
                this.glossTotalPage = totalPage;
                this.page += 1;
                this.$set(this, "glossList", data);
            });
        },
        scroll(scrollData) {
            //console.log(scrollData);
        },
        switchCol(col) {
            this.col = col;
            console.log(this.col);
        },
        loadmore() {
            if (this.page > this.glossTotalPage) {
                return;
            }
            this.loading = true;
            getGlossary(
                this.indexkeyword,
                this.indexkey,
                this.per_page,
                this.page
            ).then((res) => {
                let data = res.data?.data || [];
                this.page += 1;
                this.glossList.push(...data);
                this.loading = false;
            });
            // let logMap = {
            //   eventType: "search",
            //   url: window.location.href,
            //   functionId: functionId({
            //     pageName: "glossary",
            //     module: "search",
            //     func: "loadmore",
            //   }),
            //   utlogMap:{
            //     keywords:{
            //       per_page:this.per_page,
            //       page:this.page,
            //       indexkey:this.indexkey,
            //       indexkeyword:this.indexkeyword
            //     }
            //   }
            // };
            // utlogMap(logMap).then((res) => {
            //   console.log(res);
            // });

        },
        getResult(word) {
            this.indexkey = this.indexkey == word ? "" : word;
            this.indexkeyword = "";
            this.page = 1;
            this.glossTotalPage = 0;
            this.getGlossary();
            let logMap = {
                eventType: "search",
                url: window.location.href,
                functionId: 'Deepbone_glossary_searchViaChar',
                utlogMap: {
                    keywords: {
                        per_page: this.per_page,
                        page: this.page,
                        indexkey: this.indexkey,
                        indexkeyword: this.indexkeyword
                    }
                }
            };
            utlogMap(logMap).then((res) => {
                // console.log(res);
            });
        },
        getGlossList() {
            if (this.indexkeyword == "") {
                alert("请输入搜索内容");
                return;
            }
            this.indexkey = "";
            this.page = 1;
            this.getGlossary();
            let logMap = {
                eventType: "search",
                url: window.location.href,
                functionId: 'Deepbone_glossary_search',
                utlogMap: {
                    keywords: {
                        per_page: this.per_page,
                        page: this.page,
                        indexkey: this.indexkey,
                        indexkeyword: this.indexkeyword
                    }
                }
            };
            utlogMap(logMap).then((res) => {
                // console.log(res);
            });
        },
        getData() {
            this.glossList.concat();
        },
        toGloss(glossary_id) {
            let logMap = {
                eventType: "clk",
                url: window.location.href,
                functionId: 'Deepbone_glossary_searchResultOpen'
            };
            utlogMap(logMap).then((res) => {
                // console.log(res);
            });
            this.$router.push({ name: "glossaryDetails", params: { glossary_id, functionId: 'Deepbone_glossary_searchResultOpen' } });
        },
    },
};
</script>
<style>
.explor {
    width: 100%;
}

.explor .search-div {
    width: 100%;
    text-align: center;
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
}

.explor .search-div .el-input__inner {
    border: 2px solid #efefef;
    border-right: none;
    padding-left: 12px !important;
}

.explor .search-div .el-input__inner:focus {
    border-color: #efefef !important;
}

.explor .search-div .el-input {
    width: 25%;
    background-color: transparent;
    overflow: hidden;
}

.el-input-group__append {
    border: none;
}

.el-input-group__append button.el-button {
    background: #72c2c9;
    color: white;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
    border-radius: 0;
    font-size: 16px;
    box-sizing: border-box;
}

.word-list {
    width: 100%;
    padding: 10px 0;
}

.word-list-ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;
    flex-wrap: wrap;
}

.word-item .el-button {
    text-transform: uppercase;
    width: 100%;
    height: 100%;
    border: none;
    padding: 0;
    font-size: 40px;
    line-height: 47px;
    text-align: center;
    color: #484d63;
}

.word-item .el-button:focus {
    background: transparent;
}

.word-item.active .el-button:focus,
.word-item.active .el-button,
.word-item.active .el-button:hover {
    background: #72c2c9;
    color: white;
}

.word-item .el-button:hover {
    background: white;
    color: #484d63;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
}

.word-item {
    width: 49px;
    height: 49px;
    margin: 0 10px 5px 0;
}

.gloss-list {
    width: 100%;
}

.gloss-list .vue-waterfall {
    /* -moz-column-count: 3; 
  -webkit-column-count: 3; 
  column-count: 3;
  -moz-column-gap: 1px;
  -webkit-column-gap: 1px;
  column-gap: 1px; */
    overflow: hidden;
}

.gloss-list .vue-waterfall .vue-waterfall-column {
    width: 32% !important;
    margin-right: 2%;
}

.gloss-list .vue-waterfall .vue-waterfall-column:last-child {
    margin-right: 0;
}

.gloss-list .vue-waterfall .vue-waterfall-column .waterfall-item {
    /* width: 32%;*/
    /* margin-right: 2%; */
    margin-bottom: 2%;
    border: 2px solid #efefef;
    padding: 20px;
    cursor: pointer;
    /* -moz-page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
  break-inside: avoid; */
}

.gloss-list .waterfall-item .title {
    font-size: 24px;
    line-height: 28px;
    height: auto;
    color: #484d63;
    word-break: break-all;
    margin-bottom: 20px;
}

.no-more {
    padding: 20px 0;
    text-align: center;
}
</style>
